export const COMPACT_MAP_WIDTH = 480; // Map-width breakpoint where the panel starts using compact behavior.

export const COMPACT_MAP_HEIGHT = 480; // Map-height breakpoint where the panel starts using compact behavior.

export const MAP_VERTICAL_CLEARANCE = 48; // Vertical space reserved when calculating the panel's maximum height.

export const MAP_HORIZONTAL_CLEARANCE = 24; // Horizontal space reserved when calculating the panel's maximum width on normal maps.

export const COMPACT_MAP_HORIZONTAL_CLEARANCE = 80; // Extra horizontal space reserved when calculating max width on compact maps.
